/**
 * Mode d'emploi et aide — helpers partagés (Batch #14.302) : icônes, tons, mini-markdown (**gras**, *italique*), recherche.
 */
import { BookOpen, CalendarClock, CalendarRange, ClipboardCheck, HardHat, Landmark, LifeBuoy, PiggyBank, Scale, TrendingUp } from "lucide-react";

export const ICONS = { HardHat, BookOpen, LifeBuoy, Landmark, Scale, CalendarClock, CalendarRange, ClipboardCheck, PiggyBank, TrendingUp };

export const TONES = {
  amber: { tile: "from-amber-50 to-amber-100 border-amber-200 text-amber-900", badge: "bg-amber-600", ring: "border-amber-200" },
  sky: { tile: "from-sky-50 to-sky-100 border-sky-200 text-sky-900", badge: "bg-sky-600", ring: "border-sky-200" },
  emerald: { tile: "from-emerald-50 to-emerald-100 border-emerald-200 text-emerald-900", badge: "bg-emerald-600", ring: "border-emerald-200" },
  slate: { tile: "from-slate-50 to-slate-100 border-slate-200 text-slate-900", badge: "bg-slate-600", ring: "border-slate-200" },
  violet: { tile: "from-violet-50 to-violet-100 border-violet-200 text-violet-900", badge: "bg-violet-600", ring: "border-violet-200" },
  rose: { tile: "from-rose-50 to-rose-100 border-rose-200 text-rose-900", badge: "bg-rose-600", ring: "border-rose-200" },
};

/** **gras** et *italique* → éléments React (sans HTML brut). */
export function md(text) {
  const parts = String(text ?? "").split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g).filter(Boolean);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) return <strong key={i} className="font-semibold text-slate-900">{p.slice(2, -2)}</strong>;
    if (p.startsWith("*") && p.endsWith("*")) return <em key={i}>{p.slice(1, -1)}</em>;
    return <span key={i}>{p}</span>;
  });
}

const norm = (s) => String(s ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

function blockText(b) {
  if (b.type === "steps") return b.items.map((s) => `${s.title} ${s.text || ""}`).join(" ");
  if (b.type === "list") return b.items.join(" ");
  if (b.type === "table") return [b.columns.join(" "), ...b.rows.map((r) => r.join(" "))].join(" ");
  if (b.type === "example") return `${b.title || ""} ${b.rows.map((r) => r.join(" ")).join(" ")}`;
  return b.text || "";
}

/** Recherche plein texte (sans accents) → [{guide, section, snippet}] */
export function searchGuides(guides, q) {
  const needle = norm(q.trim());
  if (needle.length < 2) return [];
  const out = [];
  for (const g of guides) {
    for (const s of g.sections) {
      const text = `${s.title} ${s.blocks.map(blockText).join(" ")}`;
      const idx = norm(text).indexOf(needle);
      if (idx >= 0) out.push({ guide: g, section: s, snippet: text.slice(Math.max(0, idx - 60), idx + 120).replace(/\*\*/g, "") });
    }
  }
  return out;
}
